import { useEffect,useState } from 'react';
import { useRecoilState } from 'recoil';
import { 
    selectedBaseModelState,
    namespaceState 
} from '../../../recoil/atoms';
import useApi from '../../../services/useApi';
import EmptyModal from '../../../compoenets/EmptyModal';
import styles from './ValidModal.module.css';

export default function ValidModal({onClose}){
    const [selectedBaseModel, ]=useRecoilState(selectedBaseModelState);
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const [data,setData]=useState(null);

    useEffect(()=>{
        useApi.get('/ngp/modelreg/mm/model/v1/validation/result?namespaceId='+nsState.id+'&userId='+userId+'&modelId='+selectedBaseModel.modelId+'&pageSize='+100)
        .then((res) => {
            setData(res.data);
        })
    },[])

    if(!data){
        return(
        <EmptyModal
        onAction={()=>{}}
        onClose={()=>onClose()}>
            <div className={styles['main']}>
                <div>Loading...</div>
            </div>
        </EmptyModal>
        )
    }else if(data.validationResult===""){
        return(
        <EmptyModal
        onAction={()=>{}}
        onClose={()=>onClose()}>
            <div className={styles['main']}>
                <div>Not validation model</div>
            </div>
        </EmptyModal>
        )
    }

    return(
        <EmptyModal
        onAction={()=>{}}
        onClose={()=>onClose()}>
            <div className={styles['main']}>
                <div className={styles['header']}>
                    <span>Model Validation</span>
                    <div>
                        {data.validationResult.message==='Model Validation Completed'?
                        <div className={styles['state-success']}>
                            <span>Success</span>
                        </div>
                        :
                        <>
                        <div className={styles['state-fail']}>
                            <span>Fail</span>
                        </div>
                        <span>{data.validationResult.message}</span>
                        </>
                        }
                    </div>
                </div>
                <div className={styles['body']}>
                    <div className={styles['body-left']}>
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>TensorFlow Version</span>
                            <div className={`${styles['item-body']} ${styles['item-version']}`}>
                                <p>
                                    <span>System</span>
                                    <span>{data.validationResult.tfSystemVersion}</span>
                                </p>
                                <p>
                                    <span>Model</span>
                                    <span>{data.validationResult.tfModelVersion}</span>
                                </p>
                            </div>
                        </div>
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Type</span>
                            <div className={styles['item-body']}>
                                <span>{data.validationResult.type}</span>
                            </div>
                        </div>
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Quantization</span>
                            <div className={styles['item-body']}>
                                <span>{data.validationResult.quantization?"Float16":"False"}</span>
                            </div>
                        </div>
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Signature</span>
                            <div className={styles['item-body']}>
                                {data.validationResult.signatures.map(item=>(
                                    <span>{item}</span>
                                ))}
                            </div>
                        </div>
                        {data.validationResult.missingSignatures&&
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Missing Signature & Output</span>
                            <div className={styles['item-body']}>
                                {Object.entries(data.validationResult.missingSignatures).map(([key,values])=>(
                                    <div className={styles['item-missing']}>
                                        <span>{key}</span>
                                        <p>
                                        {values.map(value=>(
                                        <span>{value}</span>
                                        ))}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>}
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Parameters</span>
                            <div className={styles['item-body']}>
                                {Object.entries(data.validationResult.defaultModelParameters).map(([key,item])=>(
                                    <span>{key}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={styles['body-right']}>
                        <div className={styles['item']}>
                            <span className={styles['item-header']}>Performance Test</span>
                            <div className={styles['item-body']}>
                                {Object.entries(data.validationResult.trainingResult).map(([key,value])=>(
                                    <p className={`${styles['item-performance']} ${value?styles['success']:styles['fail']}`}>
                                        <span>Train loss</span>
                                        <span>{value}</span>
                                    </p>
                                ))}
                                {Object.entries(data.validationResult.evaluationResult).map(([key,value])=>(
                                    <p className={`${styles['item-performance']} ${value?styles['success']:styles['fail']}`}>
                                        <span>Evaluation {key}</span>
                                        <span>{value}</span>
                                    </p>
                                ))}
                                {Object.entries(data.validationResult.testResult).map(([key,value])=>(
                                    <p className={`${styles['item-performance']} ${value?styles['success']:styles['fail']}`}>
                                        <span>Test {key}</span>
                                        <span>{value}</span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </EmptyModal>
    )
}

const data_success=
{
    "resultCode": 0,
    "message": "SUCCESS",
    "validationResult" : {
         "modelId": "model-id-123",
        "type": "classification",
        "quantization":true,
         "taskId": "955a3b39-2188-4650-aacc-4ec07d2e13e4",
         "createdBy": 111,
         "tfModelVersion": "2.14.1",
         "tfSystemVersion": "2.14.1",
         "signatures": [
             "infer",
            "train",
          "save",
            "restore",
          "evaluate"
        ],
      "defaultModelParameters": {
            "Clipnorm": {
              "value": "1.0"
            },
            "LearningRate": {
              "value": "0.05"
            }
      },
        "trainingResult": {
            "loss" : 100
        },
      "evaluationResult": {
            "accuracy": 0.8
        },
      "testResult": {
            "accuracy": 0.7
           },
        "message": "SUCCESS"
    }
}


const data_fail=
{
    "validationResult" : {
          "modelId": "model-id-123",
          "type": "classification",
          "taskId": "955a3b39-2188-4650-aacc-4ec07d2e13e4",
          "quantization":false,
          "createdBy": 111,
          "tfModelVersion": "2.14.1",
          "tfSystemVersion": "2.14.1",
            "signatures": [
            "save",
            "restore",
          "evaluate"
         ],
        "defaultModelParameters": {
             "Clipnorm": {
              "value": "1.0"
            },
             "LearningRate": {
                "value": "0.05"
            }
        },
        "missingSignatures": {
            "train": ["loss"],
            "infer": ["predictions", "output"]
        },
        "trainingResult": {
             "loss" : null
        },
        "evaluationResult": {
           "accuracy": 0.8
        },
        "testResult": {
            "accuracy": 0.7
        },
        "message": "TFLite model conversion is only supported in TensorFlow versions 1.12 and above"
    }
}